<template>
  <SubPage1></SubPage1>
  <footer class="mt-5">
    <div class="container">
      <div class="row">
        <p class="text-center">©2024 八斗故事村</p>
      </div>
    </div>
  </footer>
</template>

<script>
import SubPage1 from '@/components/StorySubpage/SubPage1.vue';

export default {
  name: 'StoryComponent',
  components: {
    SubPage1,
  },
  methods: {
    goToTargetPage(num) {
      this.$emit('updatePageIndex', num);
      this.$router.push(`/subpage${num}`);
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  padding: 0.5rem;
  background: #7bcadd;
  color: #fff;
  font-family: "Noto Sans TC", sans-serif;
  font-weight: 600;
}

</style>
